module.exports = __webpack_public_path__ + "static/media/SpiderRustle.e00647af.mp3";